export const TOGGLE_SHOW_SNOOZED = "bonfire/insights/TOGGLE_SHOW_SNOOZED";
export const UPDATE_GROUP_BY_OPTION = "bonfire/insights/UPDATE_GROUP_BY_OPTION";
export const UPDATE_SORT_BY_OPTION = "bonfire/insights/UPDATE_SORT_BY_OPTION";
